<template>
    <v-sheet>
        <v-sheet class="text-center mb-20 mb-lg-40">
            <h3 class="tit mb-8 mb-lg-16">작성 완료</h3>
            <p class="page-text--lg grey-6--text">
                이력서 작성이 완료 되었습니다. <br />
                해당 내용으로 지원하시겠습니까?
            </p>
        </v-sheet>
        <div class="v-btn-group mt-0">
            <v-btn v-bind="{ loading }" outlined color="grey-d" class="min-w-140px min-w-lg-160px" @click="$emit('prev')"><span class="grey-6--text">이전으로</span></v-btn>
            <v-btn v-bind="{ loading }" color="primary" class="min-w-140px min-w-lg-160px" @click="apply"><span>지원하기</span></v-btn>
        </div>
    </v-sheet>
</template>

<script>
import api from "@/api";
import { initApplication } from "@/assets/variables";

export default {
    props: {
        value: { type: Object, default: () => ({}) }, // form
        loading: { type: Boolean, default: false },
    },
    methods: {
        sync() {
            this.$data._micepecRecords = [...(this.value?._micepecRecords || [])];
        },
        emit() {
            this.$emit("input", { ...this.value, _micepecRecords: [...(this.$data._micepecRecords || [])] });
        },
        async apply() {
            if (this.loading) return;
            else this.$emit("setLoading", true);

            try {
                const { _recruitment } = this.value;
                const { application } = await api.v1.recruitments.application.putApply({ _recruitment });
                this.$emit("input", initApplication(application));
                alert("저장되었습니다");
                this.$emit("setLoading", false);
            } finally {
                this.$emit("setLoading", false);
            }
        },
    },
};
</script>
